import { useMemo, useState } from "react"

import { useOrganization } from "src/data/organizations/hooks/useOrganization"
import { useFetchMembers } from "src/data/organizations/queries/memberQueries"
import { createUnassignedOption } from "src/data/taskManagement/taskManagementFilters"
import { useTranslate } from "src/i18n/useTranslate"

export const useAssigneeOptions = (initialValue: string) => {
  const { orgId } = useOrganization()
  const { tPlaceholder } = useTranslate()
  const [nameSearch, setNameSearch] = useState("")

  const unassignOption = createUnassignedOption(tPlaceholder)

  const nameSearchIsValid =
    nameSearch && nameSearch.length > 0 && nameSearch !== unassignOption.label

  const members = useFetchMembers({
    orgId,
    filter: {
      full_name: nameSearchIsValid ? nameSearch : undefined,
    },
  })

  const assigneeOptions = useMemo(() => {
    return (
      members.data?.members.map((mem) => ({
        label: mem.name,
        value: mem.member_id,
      })) ?? []
    )
  }, [members])

  function handleSearch(value: string) {
    setNameSearch(value)
  }

  const initialAssignee =
    assigneeOptions.find((m) => m.value === initialValue) ?? unassignOption

  const isSearching = nameSearchIsValid && nameSearch !== initialAssignee?.label

  const showUnassignedOption = !isSearching

  const options = showUnassignedOption
    ? [unassignOption, ...assigneeOptions]
    : assigneeOptions

  return {
    options,
    initialAssignee,
    handleSearch,
  }
}
